import * as yup from 'yup';
import 'yup-phone';
import { FormFields } from 'src/components/AuthNew/components/RegistrationForm/types';
import { i18n } from '@lt/localization';

export const validationName = yup
  .string()
  .required(i18n.t('checkout.registrationForm.name.required'))
  .matches(
    /^\s*(?=.{1,50}$)[A-Za-zА-Яа-яёЁ]+(?:[-][A-Za-zА-Яа-яёЁ]+)?\s*$/,
    i18n.t('checkout.registrationForm.matches'),
  );
export const validationSurname = yup
  .string()
  .required(i18n.t('checkout.registrationForm.surname.required'))
  .matches(
    /^\s*(?=.{1,50}$)[A-Za-zА-Яа-яёЁ]+(?:[-][A-Za-zА-Яа-яёЁ]+)?\s*$/,
    i18n.t('checkout.registrationForm.matches'),
  );
export const validationEmail = yup
  .string()
  .matches(
    /^(([^<>()[\]\\/*=.,;:\s@"]{1,50}(\.[^<>()[\]\\/*=.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9а-яА-ЯёЁ-]+\.)+[a-zA-Zа-яА-ЯёЁ]{2,}))$/,
    i18n.t('checkout.registrationForm.email.inputError'),
  )
  .required(i18n.t('checkout.registrationForm.email.required'));

export const validationPhone = yup
  .string()
  // в качестве первых двух параметров передаем undefined, чтобы оставить их дефолтными
  // третьим параметром передаем error-message
  .phone(
    undefined,
    undefined,
    i18n.t('checkout.registrationForm.phone.inputError'),
  )
  .required(i18n.t('checkout.registrationForm.phone.required'));

export const validationSchema = yup.object({
  [FormFields.Name]: validationName,
  [FormFields.Surname]: validationSurname,
  [FormFields.Email]: validationEmail,
  [FormFields.Phone]: validationPhone,
});
